module.exports = __webpack_public_path__ + "images/6_NOON_Switches.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/6_NOON_Switches.png
// module id = 263
// module chunks = 0